<script>

import api from '@/api'

import { alertSuccess, alertError } from '@/helpers/swal'
import { authGetters } from '@/state/helpers'
import LicenseSummaryTable from '@/components/LicenseSummaryTable.vue'



export default {

  data() {

    return {

      pagetitle: 'Devices',

      credentials: [],

      categories: [],

      deviceTypes: [],

      device: {

        id: null,

        host: '',

        ipAddress: '',

        categoryId: '',

        credentialId: '',

        deviceTypeId: '',

        latitude: '0',

        longitude: '0',

        description: '',

        description1: '',

        description2: '',

        description3: '',

        registeredFor: '',

      },

      accountNumber: '',
      licenseInfo: null,

      errors: {

        host: '',

        ipAddress: '',

        category: '',

        credentialId: '',

        deviceType: '',

        latitude: '',

        longitude: '',

        description: '',

      },

      syncErrors: {

        accountNumber: '',

      },

      saveBtnDisabled: false,
      applyBtnDisabled: false,

    }

  },

  computed: {
    ...authGetters,
    isEditMode() {
      return !!this.$route.params.id
    },
    isEzemanageUser() {
      return this.authUserIsEzemanage
    },
  },

  components: {
    LicenseSummaryTable,
  },

  async mounted() {

    await this.getCredentials()

    await this.getCategories()

    await this.getDeviceTypes()

    const deviceId = this.$route.params.id

    if (deviceId) {

      await this.getDeviceData(deviceId)

    }

  },

  methods: {

    async getCredentials() {

      const params = {

        size: 100,

      }

      await api.get('/credentials/getCredentials/basic', { params }).then((response) => {

        this.credentials = response.data.credentialsList || []

      })

    },



    async getCategories() {

      const params = {

        size: 100,

      }

      await api.get(`${window.apiUrl}/category/getCategories/list/basic`, { params }).then((response) => {

        this.categories = response.data.categoriesList

      })

    },



    async getDeviceTypes() {

      const params = {

        size: 100,

      }

      await api.get('/device-types/list/basic', { params }).then((response) => {

        this.deviceTypes = response.data.deviceTypesList

      })

    },



    async getDeviceData(deviceId) {

      await api.get(`/devices/${deviceId}`).then((response) => {

        const d = response.data || {}

        this.device = Object.assign(this.device, d)

        this.device.description1 = d.description1 || d.description || ''

        this.device.description2 = d.description2 || ''

        this.device.description3 = d.description3 || ''

        this.device.registeredFor = d.registeredFor || ''

        this.accountNumber = d.accountNumber || this.extractAccountFromHost(d.host) || ''

        this.licenseInfo = d.licenseInfo || null

      })

    },



    extractAccountFromHost(host) {
      if (!host) return ''
      const match = String(host).match(/(?<!\d)\d{3}-\d{3}-\d{2}-\d{4}-\d{4}(?!\d)/)
      return match ? match[0] : ''
    },

    saveDevice() {

      if (!this.validateRequest()) return



      this.saveBtnDisabled = true

      let data = new FormData()

      if (this.device.id) {

        data.append('id', this.device.id)

      }

      data.append('host', this.device.host)

      data.append('ipAddress', this.device.ipAddress || '')

      data.append('categoryId', this.device.categoryId)

      data.append('credentialId', this.device.credentialId)

      data.append('deviceTypeId', this.device.deviceTypeId)

      data.append('latitude', this.device.latitude)

      data.append('longitude', this.device.longitude)

      if (this.isEditMode) {
        data.append('description1', this.device.description1 || '')
        if (this.isEzemanageUser) {
          data.append('description2', this.device.description2 || '')
          data.append('description3', this.device.description3 || '')
          data.append('accountNumber', this.accountNumber?.trim() || '')
        }
      } else {
        data.append('description', this.device.description)
      }



      this.device.id ? this.updateDevice(data) : this.addDevice(data)

    },



    addDevice(data) {

      api

        .post('/devices/add', data, {

          headers: {

            'Content-Type': 'multipart/form-data',

          },

        })

        .then(() => {

          alertSuccess('Device added successfully')

          this.$router.push({ name: 'devices' })

        })

        .catch((error) => {

          alertError(

            error?.response?.data?.message || 'Something went wrong'

          )

        })

        .finally(() => {

          this.saveBtnDisabled = false

        })

    },



    updateDevice(data) {

      api

        .post(`/devices/modify/${this.device.id}`, data)

        .then(() => {

          alertSuccess('Device updated successfully')

          this.$router.push({ name: 'devices' })

        })

        .catch((error) => {

          alertError(error?.response?.data?.message || 'Something went wrong')

        })

        .finally(() => {

          this.saveBtnDisabled = false

        })

    },



    validateRequest() {

      let isValid = true

      this.errors = {}

      if (!this.device.host) {

        this.errors.host = 'Host is required'

        isValid = false

      }

      if (this.device.ipAddress && this.device.ipAddress.length > 45) {

        this.errors.ipAddress = 'IP Address must not exceed 45 characters'

        isValid = false

      }

      if (!this.device.credentialId) {

        this.errors.credentialId = 'Credential field is required'

        isValid = false

      }

      if (!this.device.categoryId) {

        this.errors.category = 'Device category is required'

        isValid = false

      }

      if (!this.device.deviceTypeId) {

        this.errors.deviceType = 'Device type is required'

        isValid = false

      }

      if (this.device.latitude === '') {

        this.errors.latitude = 'Latitude field is required'

        isValid = false

      }

      if (this.device.longitude === '') {

        this.errors.longitude = 'Longitude is required'

        isValid = false

      }

      if (!this.isEditMode && !this.device.description) {

        this.errors.description = 'Description field is required'

        isValid = false

      }

      return isValid

    },



    validateSyncRequest() {

      let isValid = true

      this.syncErrors = {}

      if (!this.accountNumber?.trim()) {

        this.syncErrors.accountNumber = 'Account number is required'

        isValid = false

      }

      return isValid

    },



    async syncEzemanage() {

      if (!this.device.id || !this.validateSyncRequest()) return



      this.applyBtnDisabled = true

      try {

        const resp = await api.post(`/devices/${this.device.id}/sync-ezemanage`, {

          accountNumber: this.accountNumber.trim(),

        })

        const data = resp.data || {}

        this.device.description2 = data.description2 || ''

        this.device.description3 = data.description3 || ''

        this.device.registeredFor = data.registeredFor || ''

        this.licenseInfo = data.licenseInfo || null

        alertSuccess(data.message || 'Synced device data from Ezemanage')

      } catch (err) {

        if (!err?.cancelled) {
          const raw = err?.response?.data?.message || err?.message || 'Failed to sync from Ezemanage'
          const message = String(raw).replace(/\s+/g, ' ').trim()
          alertError(message.length > 120 ? message.slice(0, 119) + '…' : message)
        }

      } finally {

        this.applyBtnDisabled = false

      }

    },

  },

}

</script>



<template>

  <div class="row">

    <div class="col-xl-6">

      <Teleport to="#elePageTitle">

        {{ pagetitle }}

      </Teleport>

      <div class="card">

        <div class="card-header d-flex align-items-center">

          <h4 class="card-title">{{ $route.params.id ? 'Edit Device' : 'Add New Device' }}</h4>

        </div>

        <div class="card-body">

          <form @submit.prevent="saveDevice()">

            <div class="row">

              <div class="col-md-6 mb-3">

                <label for="name-input" class="form-label">Host</label>

                <input type="text" class="form-control" placeholder="Device host / name" id="name-input" v-model="device.host" />

                <div v-if="errors.host" class="invalid-feedback d-block">{{ errors.host }}</div>

              </div>

              <div class="col-md-6 mb-3">

                <label for="ip-address-input" class="form-label">IP Address</label>

                <input type="text" class="form-control" placeholder="Optional IPv4 or IPv6" id="ip-address-input" v-model="device.ipAddress" maxlength="45" />

                <div v-if="errors.ipAddress" class="invalid-feedback d-block">{{ errors.ipAddress }}</div>

              </div>

              <div class="col-md-6 mb-3">

                <label for="credential-input" class="form-label">Credentials</label>

                <select id="credential-input" class="form-select" v-model="device.credentialId" required>

                  <option selected disabled value="">Select</option>

                  <option v-for="(credential, credentialIndex) in credentials" :key="credentialIndex" :value="credential.id">{{ credential.profileName }}</option>

                </select>

                <div v-if="errors.credentialId" class="invalid-feedback">{{ errors.credentialId }}</div>

              </div>

              <div class="col-md-6 mb-3">

                <label for="category-input" class="form-label">Category</label>

                <select id="category-input" class="form-select" v-model="device.categoryId" required>

                  <option selected disabled value="">Select</option>

                  <option v-for="(category, categoryIndex) in categories" :key="categoryIndex" :value="category.id">{{ category.categoryName }}</option>

                </select>

                <div v-if="errors.category" class="invalid-feedback">{{ errors.category }}</div>

              </div>

              <div class="col-md-6 mb-3">

                <label for="deviceType-input" class="form-label">Device Type</label>

                <select id="deviceType-input" class="form-select" v-model="device.deviceTypeId" required>

                  <option selected disabled value="">Select</option>

                  <option v-for="(type, typeIndex) in deviceTypes" :key="typeIndex" :value="type.id">{{ type.deviceType }}</option>

                </select>

                <div v-if="errors.deviceType" class="invalid-feedback">{{ errors.deviceType }}</div>

              </div>

              <div class="col-md-6 mb-3">

                <label for="latitude-input" class="form-label">Latitude</label>

                <input type="text" class="form-control" placeholder="Latitude" id="latitude-input" v-model="device.latitude" />

                <div v-if="errors.latitude" class="invalid-feedback">{{ errors.latitude }}</div>

              </div>

              <div class="col-md-6 mb-3">

                <label for="longitude-input" class="form-label">Longitude</label>

                <input type="text" class="form-control" placeholder="Longitude" id="longitude-input" v-model="device.longitude" />

                <div v-if="errors.longitude" class="invalid-feedback">{{ errors.longitude }}</div>

              </div>



              <div v-if="!isEditMode" class="col-md-12 mb-3">

                <label for="description-input" class="form-label">Description</label>

                <textarea class="form-control" id="description-input" placeholder="Write description here" rows="3" v-model="device.description"></textarea>

                <div v-if="errors.description" class="invalid-feedback">{{ errors.description }}</div>

              </div>



              <template v-if="isEditMode && isEzemanageUser">

                <div class="col-md-12 mb-3">

                  <label for="account-number-input" class="form-label">Ezemanage Account Number</label>

                  <input

                    type="text"

                    class="form-control"

                    id="account-number-input"

                    placeholder="e.g. 971-004-05-0577-0007"

                    v-model="accountNumber"

                  />

                  <div v-if="syncErrors.accountNumber" class="invalid-feedback d-block">{{ syncErrors.accountNumber }}</div>

                </div>

                <div class="col-md-12 mb-3 d-grid">

                  <button class="btn btn-outline-primary" :disabled="applyBtnDisabled" @click.prevent="syncEzemanage">

                    <i class="bx bx-sync"></i>

                    <span class="ms-1">Sync Ezemanage</span>

                  </button>

                </div>



                <div class="col-md-12 mb-3">

                  <label for="registered-for-input" class="form-label">Registered For</label>

                  <input

                    type="text"

                    class="form-control"

                    id="registered-for-input"

                    v-model="device.registeredFor"

                    readonly

                  />

                </div>



                <div class="col-md-12 mb-3">

                  <label for="description1-input" class="form-label">Description 1 (About device)</label>

                  <textarea class="form-control" id="description1-input" placeholder="Write description about the device" rows="3" v-model="device.description1"></textarea>

                </div>



                <div class="col-md-12 mb-3">

                  <label for="description2-input" class="form-label">Description 2 (Remarks)</label>

                  <textarea class="form-control" id="description2-input" placeholder="Write remarks here" rows="3" v-model="device.description2"></textarea>

                </div>



                <div class="col-md-12 mb-3">

                  <label for="description3-input" class="form-label">Description 3 (Details)</label>

                  <textarea class="form-control" id="description3-input" placeholder="Description from Ezemanage" rows="2" v-model="device.description3"></textarea>

                </div>



                <div class="col-md-12 mb-3" v-if="licenseInfo">

                  <label class="form-label">License Summary</label>

                  <LicenseSummaryTable :license-info="licenseInfo" :device="device" />

                </div>

              </template>

              <template v-else-if="isEditMode">
                <div class="col-md-12 mb-3">
                  <label for="description1-input" class="form-label">Description 1 (About device)</label>
                  <textarea class="form-control" id="description1-input" placeholder="Write description about the device" rows="3" v-model="device.description1"></textarea>
                </div>
              </template>

            </div>

          </form>

        </div>

        <div class="card-footer">

          <div class="row">

            <div class="col-7">

              <router-link to="/devices" class="btn btn-light d-inline-flex align-items-center">

                <i class="bx bx-arrow-back font-size-16 me-1"></i>

                Back to List

              </router-link>

            </div>

            <div class="col-5 d-flex justify-content-end">

              <button class="btn btn-success d-flex align-items-center" @click.prevent="saveDevice()" :disabled="saveBtnDisabled">

                <i v-if="!saveBtnDisabled" class="bx bx-check-double font-size-16"></i>

                <i v-else class="bx bx-loader bx-spin font-size-16"></i>

                <span class="ms-1">Save</span>

              </button>

            </div>

          </div>

        </div>

      </div>

    </div>

  </div>

</template>


